import { SerializedConstructor } from '@langchain/core/load/serializable';

import { HubCardProps } from '@/Pages/HubRepo/HubCard';
import { EMessageType } from '@/components/EditableMessage/types';
import { VarMappingProps } from '@/components/EvaluatorCrudPane/types';
import { MessageCapability } from '@/types/schema';

import type { PlaygroundRunState } from '../../Playground.types';
import { ManifestOptions } from '../../utils/types';
import { ManifestNavigationValue } from './ManifestNavigation';

export interface ManifestHubProps<TValue> {
  value: TValue;
  options: Record<string, unknown>;
  cardProps: Pick<HubCardProps, 'actions'>;
}

export interface ManifestSecretProps {
  value: Record<string, string>;
  onChange: (value: Record<string, string>) => void;
}

export type ManifestVariant = 'card' | 'pane' | 'evaluator' | 'table';

export interface ManifestEditorProps<TValue> {
  variant: ManifestVariant;
  navigation?: ManifestNavigationValue;
  value: TValue;
  onChange: (value: TValue) => void;
  options: ManifestOptions;
  onOptionsChange: (value: ManifestOptions) => void;
  withAdditionalKeys?: boolean;
  secrets?: Record<string, string>;
  readOnly?: boolean;
  sequence?: {
    path: string;
    runs: PlaygroundRunState['runs'] | undefined;
  };
  onDeleteSchema?: () => void;
  hideTools?: boolean;
  provider?: string;
  hideTemplateFormatSelector?: boolean;
  outputSchemaAsModal?: boolean;
  actions?: React.ReactNode;
  minimizedSchema?: boolean;
  disabledMessageTypes?: EMessageType[];
  disabledMessageCapabilities?: MessageCapability[];
  isAllCollapsed?: boolean;
  setIsAllCollapsed?: (isAllCollapsed: boolean) => void;
  variableMappingProps?: VarMappingProps;
  onVariableCreated?: (variableName: string, inputContent: string) => void;
  existingVariables?: string[];
}

export interface ManifestPreviewProps<TValue> {
  variant?: 'card' | 'line';
  value: TValue;
  options: ManifestOptions;
  onClick?: () => void;
}

export interface KwargsSerializedConstructor<
  TKwargs extends Record<string, unknown>
> extends SerializedConstructor {
  kwargs: TKwargs;
}

export const tableVariantRowClass =
  'flex flex-row justify-between gap-0 py-3 px-6 odd:rounded-md odd:bg-secondary';
export const tableVariantLabelClass = 'text-md font-medium';
export const tableVariantContainerClass = 'gap-0 overflow-hidden rounded-md';
